// FINAL FIX - Aggressive child link blocking
jQuery(document).ready(function($) {
    var $offCanvasNav = $('.offcanvas-menu, .overlay-menu');
    
    // Remove buggy handlers
    $offCanvasNav.off('click touchstart', 'li a, .menu-expand');
    
    var touchStartY = 0;
    var hasMoved = false;
    
    // Track touch
    $offCanvasNav[0].addEventListener('touchstart', function(e) {
        if (e.touches && e.touches.length > 0) {
            touchStartY = e.touches[0].clientY;
            hasMoved = false;
        }
    }, true);
    
    $offCanvasNav[0].addEventListener('touchmove', function(e) {
        if (e.touches && e.touches.length > 0) {
            if (Math.abs(e.touches[0].clientY - touchStartY) > 5) {
                hasMoved = true;
            }
        }
    }, true);
    
    // BLOCK child links on touchend FIRST
    $offCanvasNav[0].addEventListener('touchend', function(e) {
        if (hasMoved) {
            var target = e.target;
            while (target && target.tagName !== 'A') {
                target = target.parentElement;
                if (target === $offCanvasNav[0]) break;
            }
            
            if (target && target.tagName === 'A' && $(target).hasClass('menu-link')) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        }
    }, true);
    
    // BLOCK child link clicks when scrolling
    $offCanvasNav.on('click', '.menu-link', function(e) {
        if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            hasMoved = false;
            return false;
        }
        // Allow navigation if not scrolling
    });
    
    // Handle PARENT links
    $offCanvasNav.on('click', '.menu-item-has-children > a, .menu-expand', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (!hasMoved) {
            var $this = $(this);
            if ($this.siblings('ul').length) {
                $this.parent('li').toggleClass('active');
                $this.siblings('ul').slideToggle();
            }
        }
        
        hasMoved = false;
        return false;
    });
    
    // Reset
    document.addEventListener('touchend', function() {
        setTimeout(function() { hasMoved = false; }, 100);
    });
});